function readField(row, camel, pascal) {
  return row?.[camel] ?? row?.[pascal] ?? "";
}

function normalizeSender(row) {
  const phoneNumberId = String(readField(row, "phoneNumberId", "PhoneNumberId") || "").trim();
  if (!phoneNumberId) return null;
  const displayName = String(
    readField(row, "senderDisplayName", "SenderDisplayName") ||
      readField(row, "label", "Label") ||
      ""
  ).trim();
  const businessNumber = String(
    readField(row, "whatsAppBusinessNumber", "WhatsAppBusinessNumber") ||
      readField(row, "displayNumber", "DisplayNumber") ||
      ""
  ).trim();
  const provider = String(readField(row, "provider", "Provider") || "").trim();
  const isDefault = Boolean(row?.isDefault ?? row?.IsDefault);
  const isActive = row?.isActive ?? row?.IsActive;

  return {
    phoneNumberId,
    displayName,
    businessNumber,
    provider,
    isDefault,
    isActive: isActive === undefined ? true : Boolean(isActive),
    label: displayName || businessNumber || phoneNumberId,
  };
}

export function normalizeSenderList(rows) {
  return (Array.isArray(rows) ? rows : [])
    .map(normalizeSender)
    .filter(Boolean);
}

export function senderLabel(sender) {
  if (!sender) return "Unknown sender";
  const parts = [sender.label];
  if (sender.businessNumber && sender.businessNumber !== sender.label) {
    parts.push(sender.businessNumber);
  }
  return parts.filter(Boolean).join(" - ");
}
